import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Blogs() {
  return (
    <Container fluid className="project-section">
      <Container>
        <Row style={{ paddingTop: "80px", paddingBottom: "80px" }}>
          <Col md={12} className="project-card">
            <h1 className="project-heading">
              My <strong className="purple">Blogs</strong>
            </h1>
            <p style={{ marginTop: 20 }}>
              Blog content is coming soon. Check back later!
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Blogs;


